import { useMemo } from 'react';
import { isEmpty } from 'lodash';

import { FilterOption } from '@/components/Filter/types';
import { UseFilterValuesType } from '@/components/FilterNew/types';
import useTagOptions from '@/modules/corporate/modules/tags/hooks/useTagOptions';

export const useTagFilterValue: UseFilterValuesType = ({ value, queryParams }) => {
  const optionsResponse = useTagOptions(
    {
      valueIds: value,
      tagId: queryParams?.tagId,
    },
    isEmpty(value), // pause the execution if value is empty array
  );

  const options: FilterOption[] = useMemo(() => {
    return (
      optionsResponse.tagOptions?.map((tag) => {
        return {
          value: tag.id,
          label: tag.name,
        };
      }) ?? []
    );
  }, [optionsResponse.tagOptions]);

  return {
    fetching: optionsResponse.fetching,
    selectedOptions: options,
    resolvedValue: options.map((option) => option.label),
  };
};
